import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { getTranslationTags } from '../getTranslationTags';
export const SelectPlanDisclaimer = () => {
  var _taxStatus$data;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  const taxStatus = module.SDK.studioOfferingApiClient.hooks.useFetchTaxStatus({});

  // TODO: Improve logic
  if (((_taxStatus$data = taxStatus.data) == null ? void 0 : _taxStatus$data.treatment) === 'INCLUSIVE') {
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "page_footer.plans_disclaimer_no_vat",
      components: getTranslationTags()
    });
  } else {
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "page_footer.plans_disclaimer_applicable_tax",
      components: getTranslationTags()
    });
  }
};
//# sourceMappingURL=SelectPlanDisclaimer.js.map